<template>
<div>
    <Loading showIn="modalLoading" />

    <ValidationObserver class="col" tag="div" ref="groupForm" v-slot="{ handleSubmit, invalid }">
        <Message />

        <CForm method="post" @submit.prevent="handleSubmit(submit)">
            <CRow>
                <CCustomSearchableInput
                    col="12"
                    vid="id"
                    :name="$t('product.category')"
                    v-model="pCatId"
                    required
                    rules="required"
                    :items="pcats"
                    itemValue="name"
                    v-if="!editMode"
                    :resultListMaxHeight="100"
                />

                <CCustomInput
                    col="12"
                    vid="sale.action_value"
                    :name="$t('v2commission.types.sale')"
                    rules="required|double_or_numeric"
                    required
                    ltr
                    v-model="cat.sale.action_value"
                >
                    <template #prepend>
                        <select
                            v-model="cat.sale.action_type"
                            class="b-a-1 px-0 px-sm-2"
                            style="border-radius: 0 5px 5px 0;"
                        >
                            <option :value="CommissionAmountType.PERCENT">درصدی</option>
                            <option :value="CommissionAmountType.AMOUNT">مقداری</option>
                        </select>
                    </template>
                    <template
                        #append-content
                    >{{ cat.sale.action_type === CommissionAmountType.PERCENT ? $t('percent') : $t('rial') }}</template>
                </CCustomInput>
            </CRow>

            <CButton
                :disabled="invalid"
                type="submit"
                color="primary"
                class="px-4 float-right"
            >{{ $t('submit') }}</CButton>
        </CForm>
    </ValidationObserver>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { CommissionAmountType } from '@/constants'

export default {
    name: 'Form',

    props: {
        cat: {
            default() {
                return {
                    meta: {
                        name: '',
                    },
                    id: '',
                    sale: {
                        action_value: CommissionAmountType.PERCENT,
                        action_type: ''
                    }
                }
            }
        },
        editMode: {
            default: false,
            type: Boolean
        },
        product_groups_cell: {
            default: () => {},
        },
        submit: {
            default: () => {},
        },
        pcats: {
            default: () => [],
        }
    },

    data() {
        return {
            myInterval: '',
            CommissionAmountType,
            fetchCount: 1,
        }
    },

    computed: {
        pCatId: {
            get() {
                return this.cat.meta ? this.cat.meta.name : ''
            },
            set(val) {
                clearInterval(this.myInterval)

                if (val.id) {
                    this.cat.id = val.id
                    this.cat.meta.name = val.name

                    return
                }

                this.myInterval = setTimeout(() => {
                    this.$emit('searchOnPCat', {
                        name: val.label
                    })
                }, 500)
            }
        }
    },
}
</script>